var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { createRoot } from "react-dom/client";
import { Closable } from "../../models/Closable";
import { getConfigVar } from "../../utils/Configuration";
import { concatClassNames, createElementWithClass } from "../../utils/Functions";
import { Button } from "./Button";
import { Tooltip } from "./Tooltip";
var Toast = /** @class */ (function (_super) {
    __extends(Toast, _super);
    function Toast(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            var elapse = _this.props.elapse;
            if ((elapse && elapse > 0) || elapse == null)
                _this.timeout = setTimeout(function () { return _this.close(); }, elapse || 3000);
        };
        _this.close = function () {
            var onClose = _this.props.onClose;
            if (_this.timeout)
                clearTimeout(_this.timeout);
            _this.setState({ closed: true });
            if (onClose)
                onClose();
        };
        _this.render = function () {
            var _a = _this.props, title = _a.title, message = _a.message, closable = _a.closable, className = _a.className, style = _a.style, elapse = _a.elapse, closed = _this.state.closed;
            if (closed)
                return React.createElement(React.Fragment, null);
            return React.createElement("div", { className: concatClassNames("dolfo-toast", className), style: style },
                (title || closable) && React.createElement("h6", null,
                    React.createElement("span", null, title),
                    closable && React.createElement(Tooltip, { label: getConfigVar("CLOSE") },
                        React.createElement(Button, { shape: "text", color: "dark", onClick: _this.close, className: "toast-close" },
                            React.createElement(FontAwesomeIcon, { icon: faXmark })))),
                message,
                ((elapse && elapse > 0) || elapse == null) && React.createElement("div", { className: "dolfo-elapse-bar", style: { animationDuration: ((elapse || 3000) / 1000) + "s" } }));
        };
        _this.state = {
            closed: false
        };
        return _this;
    }
    Toast.show = function (props) {
        var container = createElementWithClass("div", "dolfo-toast-container"), position = props.position, toastPos = position || "top-right", root = createRoot(container), reposition = function () {
            var siblings = document.body.querySelectorAll(".dolfo-toast-container." + toastPos), siblingsToCheck = toastPos.startsWith("top") ? siblings : Array.from(siblings).reverse();
            var top = 0;
            siblingsToCheck.forEach(function (s) {
                if (toastPos.startsWith("top"))
                    s.style.top = top + "px";
                else
                    s.style.bottom = top + "px";
                top += s.offsetHeight + 10;
            });
        }, close = function () {
            if (props.onClose)
                props.onClose();
            root.unmount();
            container.remove();
            reposition();
        }, closable = new Closable(close);
        container.classList.add(toastPos);
        root.render(React.createElement(Toast, __assign({}, props, { onClose: closable.close })));
        document.body.appendChild(container);
        reposition();
        return closable;
    };
    return Toast;
}(React.Component));
export { Toast };
